/**
 * <faq-navigation> — Pill-based jump-to navigation + back-to-top buttons.
 */
class FaqNavigation extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-faq-pill]').forEach((pill) => {
      pill.addEventListener('click', this.#handlePillClick);
    });

    this.#handleHash();

    document.querySelectorAll('[data-back-to-top]').forEach((btn) => {
      btn.addEventListener('click', this.#handleBackToTop);
    });
  }

  /**
   * Smooth-scroll to the target category on pill click.
   * @param {Event} event
   */
  #handlePillClick = (event) => {
    event.preventDefault();
    const id = event.currentTarget.getAttribute('href')?.replace('#', '');
    const target = id && document.getElementById(id);
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', `#${id}`);
  };

  /**
   * Scroll back to the top of the page.
   * @param {Event} event
   */
  #handleBackToTop = (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.replaceState(null, '', window.location.pathname);
  };

  /**
   * If the URL has a hash on load, scroll to that section.
   */
  #handleHash() {
    const hash = window.location.hash.replace('#', '');
    if (!hash) return;

    requestAnimationFrame(() => {
      const target = document.getElementById(hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
}

if (!customElements.get('faq-navigation')) {
  customElements.define('faq-navigation', FaqNavigation);
}
